module.exports = function(app){
    /*
        Summary: Displays a loading bar in percentage style
            * Display can be delayed using start-after-seconds="3" (defaults to 3)
            * Starting point of progress can be set using start-at="25" (this sets either 25% or 25 of Number depending on the style chosen (defaults to 20% or 1)
            * seconds-to-load-fully="10" is used for setting the time after which the bar will be fully loaded (defaults to 5, only applicable on auto refresh mode)
            * min-display-seconds is the minimum time of the loading bar to be active before the promises returned by methods in the  are resolved
            * change-rate-after-seconds and change-rate-at-percentage can be used to change the rate at which the bar fills.  If defined, the fill rate before change-rate-at-percentage will be calculated based on change-rate-after-seconds; the fill rate after change-rate-at-percentage will be calculated so the total fill time is equal to seconds-to-load-fully
            * refresh-rate="1" is seconds in between bar refreshes (defaults to 0.03)
            * get-control-handles="function(controlsObject)" a function that can be defined on the caller scope and given to this directive.  It will be called with a controlsObject argument which contains methods that can provide control of this directive.  controlsObject.fillBar() gets the bar to 100% at any time; controlsObject.stopBar() cancels the bar progress; controlsObject.setProgress() sets the progress to a specific value
     */

    app.directive('loadingBar', ['$timeout', '$q', function($timeout, $q){
        return {
            restrict: 'A',
            replace: true,
            template: require('articles/loadingBar.html'),
            scope: {
                label: "@?",                    //Display text
                startAfterSeconds: "@?",        //seconds to wait before appearing
                startAt: "@?",                  //starting progress at the point of appearing
                secondsToLoadFully: "@?",          //total time to take to get to fully loaded
                minDisplaySeconds: "@?",        //minimum display time
                changeRateAfterSeconds: "@?",   //seconds before the fill rate gets recalculated
                changeRateAtPercentage: "@?",   //value at which the fill rate gets recalculated
                refreshRate: "@?",              //how often should progress be updated in seconds
                getControlHandles: "&"          //this object has methods which can be called from other scopes
            },
            compile: function(){
                return {
                    pre:function(scope, iElement, iAttrs, controller){
                        scope.initialize();
                    },
                    post:function(scope, iElement, iAttrs){
                        //intentionally empty
                    }
                };
            },
            //link: function(scope){
            //    scope.initialize();
            //},
            controller: ['$scope', '$element',
                function($scope, $element){
                    //set a private functions container
                    this.private = {};

                    var
                        self = this.private,
                        progressElement = $element.find('.progress-fill'),
                        nextProgressCycle;

                    self.minDisplayTimeDeferred = $q.defer();

                    // f = 11
                    self._setDefaults = function(){
                        $scope.maxValue = 90;
                        $scope.label = $scope.label || 'Loading...';
                        $scope.startAt = parseFloat($scope.startAt || 0);
                        $scope.startAfterSeconds = parseFloat($scope.startAfterSeconds || 0);
                        $scope.minDisplaySeconds = parseFloat($scope.minDisplaySeconds || 1);
                        $scope.secondsToLoadFully = parseFloat($scope.secondsToLoadFully || 30);
                        $scope.refreshRate = parseFloat($scope.refreshRate || 0.03);
                        $scope.changeRateAfterSeconds = parseFloat($scope.changeRateAfterSeconds || 2);
                        $scope.changeRateAtPercentage = parseFloat($scope.changeRateAtPercentage || 30);

                        //integrity checks
                        if($scope.changeRateAfterSeconds >= $scope.secondsToLoadFully){
                            throw('Loading Bar Directive Error: change-rate-after-seconds has to be greater than stop-after-seconds.');
                        }
                        if($scope.changeRateAtPercentage < $scope.startAt){
                            throw('Loading Bar Directive Error: change-rate-at needs to be >= start-at and < max-value.');
                        }
                    };

                    // f = 2
                    self._getIncrementValue = function(currentValue){
                        var
                            progressValuePerSecond = currentValue < $scope.changeRateAtPercentage
                                ? ($scope.changeRateAtPercentage / $scope.changeRateAfterSeconds)
                                : (($scope.maxValue - $scope.changeRateAtPercentage) / ($scope.secondsToLoadFully  - $scope.changeRateAfterSeconds));

                        return progressValuePerSecond * $scope.refreshRate;
                    };

                    // f = 2
                    self._incrementProgress = function(curValue){
                        var newProgressValue = curValue + self._getIncrementValue(curValue);
                        //cannot progress past the $scope.maxValue
                        newProgressValue = newProgressValue > $scope.maxValue
                            ? $scope.maxValue
                            : newProgressValue;

                        progressElement.css('width', newProgressValue + '%');
                        $scope.currentProgress = Math.floor(newProgressValue) + '%';

                        return newProgressValue;
                    };

                    // f = 3
                    self._scheduleIncrementProgress = function(curValue){
                        var newProgressValue;

                        if(curValue < $scope.maxValue){
                            newProgressValue = self._incrementProgress(curValue);
                            nextProgressCycle = $timeout(
                                function(){
                                    self._scheduleIncrementProgress(newProgressValue);
                                } , $scope.refreshRate * 1000);
                            return true;
                        }
                        return false;
                    };

                    // f = 2
                    self._startProgress = function(){
                        //track the minimum time to display the progress bar
                        $timeout(function(){
                            self.minDisplayTimeDeferred.resolve();
                        }, $scope.minDisplaySeconds * 1000);

                        //activate
                        $element.addClass('active');
                        self._scheduleIncrementProgress($scope.startAt);
                    };

                    // f = 2
                    self._completeProgress = function(){
                        var completeDefer = $q.defer();

                        $timeout.cancel(nextProgressCycle);

                        $timeout(function(){ //give time for animations to complete
                            $element.removeClass('active');
                            completeDefer.resolve();
                        }, 400);

                        return completeDefer.promise;
                    };

                    //external control functions
                    //these will be passed to a function defined on the caller's scope through getControlHandles
                    self.controlFunctions = {
                        // f = 2
                        fillBar: function(){
                            return self.minDisplayTimeDeferred.promise.then(
                                function(){
                                    self._incrementProgress($scope.maxValue);
                                    return self._completeProgress();
                                }
                            );
                        },

                        // f = 2
                        stopBar: function(){
                            return self.minDisplayTimeDeferred.promise.then(
                                function(){
                                    return self._completeProgress();
                                }
                            );
                        },

                        // f = 1
                        setProgress: function(progress){
                            $timeout.cancel(nextProgressCycle);
                            self._scheduleIncrementProgress(progress);
                        }
                    };

                    $scope.initialize = function(){
                        self._setDefaults();
                        $timeout(self._startProgress, $scope.startAfterSeconds * 1000);
                        $scope.getControlHandles({controlsObject: self.controlFunctions});
                    };
                }
            ]
        };
    }]);
};